import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Upload: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 20.613 20"
    >
      <rect
        id="Rectangle_1389"
        data-name="Rectangle 1389"
        width="20"
        height="20"
        fill="currentColor"
        opacity="0"
      />
      <g
        id="Icon_feather-upload-cloud"
        data-name="Icon feather-upload-cloud"
        transform="translate(0.542 1.937)"
      >
        <path
          id="Path_5975"
          data-name="Path 5975"
          d="M18.752,22.126a.748.748,0,0,1-.53-.22l-2.846-2.846L12.53,21.906a.75.75,0,0,1-1.061-1.061l3.376-3.376a.75.75,0,0,1,1.061,0l3.376,3.376a.75.75,0,0,1-.53,1.28Z"
          transform="translate(-5.337 -9.656)"
          fill="currentColor"
        />
        <path
          id="Path_5976"
          data-name="Path 5976"
          d="M18,26.346a.75.75,0,0,1-.75-.75V18a.75.75,0,1,1,1.5,0v7.6A.75.75,0,0,1,18,26.346Z"
          transform="translate(-7.961 -9.656)"
          fill="currentColor"
        />
        <path
          id="Path_5977"
          data-name="Path 5977"
          d="M17.862,18.241a.75.75,0,0,1-.36-1.409,3.47,3.47,0,0,0-1.659-6.517H14.781a.75.75,0,0,1-.726-.562A6,6,0,1,0,3.746,15.23a.75.75,0,1,1-1.124.993A7.5,7.5,0,1,1,15.338,8.815h.506a4.97,4.97,0,0,1,2.376,9.334A.747.747,0,0,1,17.862,18.241Z"
          transform="translate(-0.741 -3.753)"
          fill="currentColor"
        />
        <path
          id="Path_5978"
          data-name="Path 5978"
          d="M18.752,22.126a.748.748,0,0,1-.53-.22l-2.846-2.846L12.53,21.906a.75.75,0,0,1-1.061-1.061l3.376-3.376a.75.75,0,0,1,1.061,0l3.376,3.376a.75.75,0,0,1-.53,1.28Z"
          transform="translate(-5.337 -9.656)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Upload;
